import { Link } from 'react-router-dom'
import { Logo } from './Logo'
import { CookieSettingsLink } from './ConsentBanner'
import './marketing-chrome.css'

// Rebuilt 2026-10-08 alongside MarketingHeader -- see that file's
// comment. Link set matches the approved reference exactly (Pricing,
// About, Contact, Terms, Privacy); Features/Integrations dropped from
// the footer too, same reasoning as the nav.
const links = [
  { to: '/pricing', label: 'Pricing' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
  { to: '/terms', label: 'Terms' },
  { to: '/privacy', label: 'Privacy' },
]

export function MarketingFooter() {
  return (
    <footer
      className="rl-dark border-t"
      style={{ borderColor: 'var(--mkt-hairline)', background: 'var(--mkt-bg)', color: 'var(--mkt-fg)' }}
    >
      <div className="mx-auto flex max-w-[1120px] flex-col gap-4 px-6 py-8 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-2.5">
          <Logo size={20} reversed />
          <span className="text-[13.5px]" style={{ color: 'color-mix(in srgb, var(--mkt-fg) 60%, transparent)' }}>
            &copy; {new Date().getFullYear()} RemindLoop. All rights reserved.
          </span>
        </div>
        <nav className="flex flex-col items-start gap-0 sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-6">
          {links.map((link) => (
            <Link key={link.to} to={link.to} className="rl-flink">
              {link.label}
            </Link>
          ))}
          <CookieSettingsLink className="rl-flink" />
        </nav>
      </div>
    </footer>
  )
}
